import { ReactElement } from "react";
import { DatabasePreferences } from "../../../lib/preferences/dto";
import { SortableItem } from "./sortableItem";

interface Props {
    preferences: DatabasePreferences[]
    prevOrderHeads: ReactElement[]
    postOrderHeads: ReactElement[]
    settedOrder?: string
    asc?: boolean
    setOrder: (order: string) => void
    setPreferences: (items: DatabasePreferences[]) => void
}

export function CustomTHead(props: Props) {
    const { preferences, setOrder, setPreferences, prevOrderHeads, postOrderHeads, settedOrder, asc } = props

    return (
        <thead key={'thead-' + JSON.stringify(preferences)} className="h-[48px] font-semibold text-neutral-500 uppercase text-text-xs sticky z-30 top-0">
            <tr className="bg-neutral-50">
                {prevOrderHeads}
                {
                    preferences.filter(pref => pref.visible).map(pref =>
                        <th key={'head-' + pref.column} className="text-left px-4 hover:bg-neutral-100">
                            <SortableItem
                                settedOrder={settedOrder}
                                key={'head-sort-' + pref.column}
                                width={pref.width!}
                                asc={asc}
                                order={pref.order}
                                setOrder={setOrder}
                                setPreferences={setPreferences}
                                id={pref.column}
                                preferences={preferences}
                            />
                        </th >
                    )
                }
                {postOrderHeads}
            </tr>
        </thead>
    )
}